<!-- 在线答辩 -->
<template>
  <div class="el-onlineDefense">
    <el-row class="page_content">
      <h1 class="head_title">在线答辩</h1>
      <div v-loading="loading">
        <template v-if="defenseList.length > 0">
          <div class="defense-card" v-for="item in defenseList" :key="item.onlineDefenseGroupId">
            <div class="card-head">
              <span class="card-title">{{ item.onlineDefenseSessionTitle }}</span>
              <el-tag :type="groupStatusMap[item.onlineDefenseGroupStatus] ? groupStatusMap[item.onlineDefenseGroupStatus].type : 'info'" size="small">
                {{ groupStatusMap[item.onlineDefenseGroupStatus] ? groupStatusMap[item.onlineDefenseGroupStatus].label : '未知状态' }}
              </el-tag>
            </div>
            <div class="card-desc" v-if="item.onlineDefenseSessionDescription">{{ item.onlineDefenseSessionDescription }}</div>
            <div class="card-info">
              <p><span class="info-label">分组名称：</span>{{ item.onlineDefenseGroupName }}</p>
              <p><span class="info-label">答辩时间：</span>{{ item.groupStartTime || '-' }} 至 {{ item.groupEndTime || '-' }}</p>
              <p><span class="info-label">资料截止：</span>{{ item.materialDeadline || '-' }}</p>
              <p v-if="item.groupStartTime && item.groupEndTime"><span class="info-label">进入时间窗：</span>{{ getEnterWindow(item) }}</p>
            </div>
            <div class="card-btns">
              <el-button type="primary" icon="el-icon-view" size="small" @click="showDetail(item)">查看详情</el-button>
              <el-button type="warning" icon="el-icon-monitor" size="small" v-if="capabilities.deviceCheckEnabled" @click="deviceCheck(item)">设备检测</el-button>
              <el-button type="success" icon="el-icon-video-camera" size="small" @click="enterRoom(item)">进入答辩</el-button>
            </div>
          </div>
        </template>
        <template v-else>
          <el-empty :description="enabled ? '暂无在线答辩安排' : '在线答辩功能未开启'" :image-size="100"></el-empty>
        </template>
      </div>
    </el-row>

    <!-- 答辩详情 -->
    <el-dialog title="答辩详情" :visible.sync="detailShow" width="900px" class="defenseDetailDialog">
      <div v-loading="detailLoading">
        <el-descriptions :column="2" border size="medium">
          <el-descriptions-item label="活动标题" :span="2">{{ detail.onlineDefenseSessionTitle || '-' }}</el-descriptions-item>
          <el-descriptions-item label="分组名称">{{ detail.onlineDefenseGroupName || (currentGroup && currentGroup.onlineDefenseGroupName) || '-' }}</el-descriptions-item>
          <el-descriptions-item label="分组状态">{{ groupStatusMap[detail.onlineDefenseGroupStatus] ? groupStatusMap[detail.onlineDefenseGroupStatus].label : '-' }}</el-descriptions-item>
          <el-descriptions-item label="答辩时间" :span="2">{{ detail.groupStartTime || '-' }} 至 {{ detail.groupEndTime || '-' }}</el-descriptions-item>
          <el-descriptions-item label="资料截止时间">{{ detail.materialDeadline || '-' }}</el-descriptions-item>
          <!-- <el-descriptions-item label="进入时间窗">{{ detail.groupStartTime ? getEnterWindow(detail) : '-' }}</el-descriptions-item> -->
          <el-descriptions-item label="允许进入时间">{{ entryWindowText }}</el-descriptions-item>
          <el-descriptions-item label="活动说明" :span="2">{{ detail.onlineDefenseSessionDescription || '-' }}</el-descriptions-item>
          <el-descriptions-item label="活动附件" :span="2">
            <template v-if="!$isEmpty(detail.onlineDefenseSessionAttachmentList)">
              <div class="session-attachment-list">
                  <template  v-for="attachment in detail.onlineDefenseSessionAttachmentList">
                      <el-button
                          :key="attachment.onlineDefenseSessionAttachmentId || attachment.attachmentUrl"
                          type="text"
                          style="margin: 0;padding: 0;color: #909399;"
                          icon="el-icon-document"
                          @click="downloadAttachment(attachment)">
                          {{ attachment.attachmentName || '附件' }}<a style="color: #409EFF;margin-left: 20px;">立即下载</a>
                      </el-button>
                      <br />
                  </template>
              </div>
            </template>
            <span v-else>无</span>
          </el-descriptions-item>
        </el-descriptions>

        <!-- 答辩资料 -->
        <div class="material-box" v-if="capabilities.materialEnabled">
          <div class="material-head">
            <span class="material-title">我的答辩资料</span>
            <el-button
              v-if="canEditMaterial"
              type="primary"
              size="small"
              icon="el-icon-upload"
              @click="uploadDialogVisible = true">
              上传资料
            </el-button>
          </div>
          <el-alert
            v-if="!canEditMaterial"
            title="已超过在线答辩资料提交截止时间，不能上传或删除资料"
            type="info"
            :closable="false"
            show-icon>
          </el-alert>
          <el-table :data="materialList" size="small" border v-if="materialList.length > 0">
            <el-table-column prop="materialName" label="资料名称" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column label="大小" width="100" align="center">
              <template slot-scope="scope">{{ formatSize(scope.row.materialSize) }}</template>
            </el-table-column>
            <el-table-column label="版本" width="70" align="center">
              <template slot-scope="scope">{{ scope.row.materialVersion || '-' }}</template>
            </el-table-column>
            <el-table-column label="同步状态" width="100" align="center">
              <template slot-scope="scope">
                <el-tag :type="syncStatusMap[scope.row.materialSyncStatus] ? syncStatusMap[scope.row.materialSyncStatus].type : 'info'" size="mini">
                  {{ syncStatusMap[scope.row.materialSyncStatus] ? syncStatusMap[scope.row.materialSyncStatus].label : '未知' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="140" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="$downLoadFile(scope.row.materialUrl, scope.row.materialName)">下载</el-button>
                <el-button type="text" size="small" class="danger-btn" v-if="canEditMaterial" @click="deleteMaterial(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-empty v-else :image-size="60" description="暂无答辩资料"></el-empty>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailShow = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 上传答辩资料弹窗 -->
    <el-dialog title="上传答辩资料" :visible.sync="uploadDialogVisible" width="560px" @close="resetUploadFiles">
      <el-upload
        ref="materialUpload"
        class="upload-demo"
        action="#"
        :auto-upload="false"
        :file-list="uploadFileList"
        :on-change="handleFileChange"
        :on-remove="handleFileRemove"
        :before-upload="beforeMaterialUpload"
        :accept="acceptedExtensions"
        multiple>
        <el-button size="small" type="primary">选择文件</el-button>
        <div slot="tip" class="el-upload__tip material-format-tip">
          <!-- <div>文档和图片：DOC、DOCX、PPT、PPTX、PDF、JPG、JPEG、PNG、GIF、ZIP</div> -->
          <div>文档和图片：DOC、DOCX、PPT、PPTX、PDF、JPG、JPEG、PNG、GIF</div>
          <div>音频：MP3、WAV、WMA、AAC、FLAC、M4A、OGA、OPUS</div>
          <div>视频：MP4、3GP、MPG、MPEG、3G2、AVI、FLV、WMV、H264、M4V、MJ2、MOV、OGG、OGV、RM、RMVB、QT、WEBM</div>
          <!-- <div>普通文件最大100MB，音频和视频单个文件最大50MB，每组最多10个资料。</div> -->
          <div>音频和视频单个文件最大 50MB</div>
        </div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="uploading" @click="submitMaterials">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "OnlineDefense",
  data() {
    return {
      loading: false, //列表加载
      enabled: true, //在线答辩功能是否开启
      capabilities: {
        enabled: true,
        materialEnabled: true,
        deviceCheckEnabled: true
      }, //能力配置
      defenseList: [], //我的答辩列表
      detailShow: false, //详情弹窗
      detailLoading: false, //详情加载
      detail: {}, //详情数据
      currentGroup: null, //当前查看的列表项
      materialList: [], //资料列表
      uploading: false, //上传中
      uploadDialogVisible: false, //上传弹窗
      uploadFileList: [], //上传文件列表
      //活动状态 1草稿 2发布中 3已发布 4进行中 5已结束 6同步失败 7已取消
      sessionStatusMap: {
        1: { label: '草稿', type: 'info' },
        2: { label: '发布中', type: 'warning' },
        3: { label: '已发布', type: 'success' },
        4: { label: '进行中', type: 'success' },
        5: { label: '已结束', type: 'info' },
        6: { label: '同步失败', type: 'danger' },
        7: { label: '已取消', type: 'info' },
      },
      //分组状态 1待创建 2创建中 3已就绪 4进行中 5归档中 6已归档 7失败 8已取消
      groupStatusMap: {
        1: { label: '待创建', type: 'info' },
        2: { label: '创建中', type: 'warning' },
        3: { label: '已就绪', type: 'success' },
        4: { label: '进行中', type: 'success' },
        5: { label: '归档中', type: 'warning' },
        6: { label: '已归档', type: 'info' },
        7: { label: '失败', type: 'danger' },
        8: { label: '已取消', type: 'info' },
      },
      //资料同步状态 1待同步 2同步中 3已同步 4失败
      syncStatusMap: {
        1: { label: '同步中', type: 'warning' },
        2: { label: '同步中', type: 'warning' },
        3: { label: '已同步', type: 'success' },
        4: { label: '同步失败', type: 'danger' },
      },
      //允许的资料扩展名
      allowExt: ['doc', 'docx', 'ppt', 'pptx', 'pdf', 'jpg', 'jpeg', 'png', 'gif', //'zip',
        'mp3', 'wav', 'wma', 'aac', 'flac', 'm4a', 'oga', 'opus',
        'mp4', '3gp', 'mpg', 'mpeg', '3g2', 'avi', 'flv', 'wmv', 'h264', 'm4v', 'mj2', 'mov', 'ogg', 'ogv', 'rm', 'rmvb', 'qt', 'webm'],
      //音视频扩展名（单文件最大50MB）
      mediaExt: ['mp3', 'wav', 'wma', 'aac', 'flac', 'm4a', 'oga', 'opus',
        'mp4', '3gp', 'mpg', 'mpeg', '3g2', 'avi', 'flv', 'wmv', 'h264', 'm4v', 'mj2', 'mov', 'ogg', 'ogv', 'rm', 'rmvb', 'qt', 'webm'],
    };
  },
  computed: {
    canEditMaterial() { //是否可以上传/删除资料（资料截止时间前）
      const detail = this.detail;
      if (this.$isEmpty(detail) || this.$isEmpty(detail.materialDeadline)) {
        return true; //无截止时间时由服务端校验
      }
      const deadline = new Date(String(detail.materialDeadline).replace(/-/g, '/')).getTime();
      return new Date().getTime() <= deadline;
    },
    entryWindowText() {
        if (!this.detail || !this.detail.groupStartTime || !this.detail.groupEndTime) return '-';
        const before = this.detail.preEnterMinutes || 0;
        const after = this.detail.endDelayMinutes || 0;
        return '开始前 ' + before + ' 分钟至结束后 ' + after + ' 分钟';
    },
    acceptedExtensions() {
      return this.allowExt.map((ext) => '.' + ext).join(',');
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() { //1.能力查询 2.我的答辩列表
      this.loading = true;
      this.$store.dispatch("user/getOnlineDefenseCapabilities").then((ret) => {
        if (ret.code === 0 || ret.code === "0") {
          this.capabilities = ret.data || {};
          this.enabled = !!(this.capabilities && this.capabilities.enabled);
          if (this.enabled) {
            this.getDefenseList();
          } else {
            this.loading = false;
            this.$message({ message: '在线答辩功能未开启', type: 'warning' });
          }
        } else {
          this.loading = false;
          this.$message({ message: ret.msg, type: 'warning' });
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    getDefenseList() { //我的答辩列表
      this.$store.dispatch("user/getOnlineDefenseList").then((ret) => {
        this.loading = false;
        if (ret.code === 0 || ret.code === "0") {
          this.defenseList = ret.data || [];
        } else {
          this.$message({ message: ret.msg, type: 'warning' });
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    showDetail(item) { //查看详情
      this.currentGroup = item;
      this.detail = {};
      this.materialList = [];
      this.detailShow = true;
      this.detailLoading = true;
      this.$store.dispatch("user/getOnlineDefenseInfo", {
        onlineDefenseGroupId: item.onlineDefenseGroupId
      }).then((ret) => {
        this.detailLoading = false;
        if (ret.code === 0 || ret.code === "0") {
          this.detail = ret.data || {};
          this.materialList = this.detail.materialList || [];
        } else {
          this.$message({ message: ret.msg, type: 'warning' });
        }
      }).catch(() => {
        this.detailLoading = false;
      });
    },
    beforeMaterialUpload(file) { //上传前校验文件类型和大小
      const fileName = String(file.name || '');
      const ext = fileName.indexOf('.') >= 0 ? fileName.split('.').pop().toLowerCase() : '';
      if (this.allowExt.indexOf(ext) < 0) {
        this.$message({ message: '资料格式不支持', type: 'warning' });
        return false;
      }
      const isMedia = this.mediaExt.indexOf(ext) >= 0;
      const maxSizeMb = isMedia ? 50 : 50; //音视频最大50MB，其他最大100MB
      if (file.size / 1024 / 1024 > maxSizeMb) {
        this.$message({ message: `文件大小不能超过 ${maxSizeMb}MB`, type: 'warning' });
        return false;
      }
      // if (this.materialList.length >= 10) {
      //   this.$message({ message: '每个分组最多上传10个资料', type: 'warning' });
      //   return false;
      // }
      return true;
    },
    uploadMaterial(option) { //自定义上传资料（已改为弹窗批量提交，保留兼容）
      return false;
    },
    handleFileChange(file, fileList) { //选择文件变化
      this.uploadFileList = fileList;
    },
    handleFileRemove(file, fileList) { //移除文件
      this.uploadFileList = fileList;
    },
    resetUploadFiles() { //关闭弹窗时清空已选文件
      this.uploadFileList = [];
      if (this.$refs.materialUpload) this.$refs.materialUpload.clearFiles();
    },
    submitMaterials() { //提交上传资料
      const files = this.uploadFileList.map((item) => item.raw).filter((file) => !!file);
      if (files.length === 0) {
        this.$message({ message: '请先选择资料', type: 'warning' });
        return;
      }
      for (let i = 0; i < files.length; i++) {
        if (!this.beforeMaterialUpload(files[i])) return;
      }
      const formData = new FormData();
      formData.append('onlineDefenseGroupId', this.detail.onlineDefenseGroupId || this.currentGroup.onlineDefenseGroupId);
      files.forEach((file) => formData.append('file', file, file.name));
      this.uploading = true;
      this.$store.dispatch("user/uploadOnlineDefenseMaterial", formData).then((ret) => {
        this.uploading = false;
        if (ret.code === 0 || ret.code === "0") {
          this.$message({ message: '答辩资料已提交', type: 'success' });
          this.uploadDialogVisible = false;
          this.refreshDetail(); //刷新详情和资料列表
        } else {
          this.$message({ message: ret.msg || '答辩资料提交失败', type: 'warning' });
        }
      }).catch(() => {
        this.uploading = false;
      });
    },
    deleteMaterial(row) { //删除资料
      this.$confirm('确定删除该资料吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$store.dispatch("user/deleteOnlineDefenseMaterial", {
          onlineDefenseMaterialId: row.onlineDefenseMaterialId
        }).then((ret) => {
          if (ret.code === 0 || ret.code === "0") {
            this.$message({ message: '删除成功', type: 'success' });
            this.refreshDetail();
          } else {
            this.$message({ message: ret.msg, type: 'warning' });
          }
        });
      }).catch(() => {});
    },
    refreshDetail() { //重新获取详情
      if (this.$isEmpty(this.detail) && this.$isEmpty(this.currentGroup)) {
        return;
      }
      this.detailLoading = true;
      this.$store.dispatch("user/getOnlineDefenseInfo", {
        onlineDefenseGroupId: this.detail.onlineDefenseGroupId || this.currentGroup.onlineDefenseGroupId
      }).then((ret) => {
        this.detailLoading = false;
        if (ret.code === 0 || ret.code === "0") {
          this.detail = ret.data || {};
          this.materialList = this.detail.materialList || [];
        }
      }).catch(() => {
        this.detailLoading = false;
      });
    },
    deviceCheck(item) { //设备检测，打开百家云官方检测页
      this.$store.dispatch("user/getOnlineDefenseDeviceTest", {
        onlineDefenseGroupId: item.onlineDefenseGroupId
      }).then((ret) => {
        if ((ret.code === 0 || ret.code === "0") && ret.data && !this.$isEmpty(ret.data.deviceTestUrl)) {
          window.open(ret.data.deviceTestUrl);
        } else {
          this.$message({ message: ret.msg || '未获取到设备检测地址', type: 'warning' });
        }
      });
    },
    enterRoom(item) { //进入直播间，每次点击重新获取最新入口地址
      this.$store.dispatch("user/getOnlineDefenseEntryUrl", {
        onlineDefenseGroupId: item.onlineDefenseGroupId
      }).then((ret) => {
        if ((ret.code === 0 || ret.code === "0") && ret.data && !this.$isEmpty(ret.data.entryUrl)) {
          window.open(ret.data.entryUrl); //只能使用服务端返回的入口地址
        } else {
          //未准备完成或不在进入时间时，保留当前页并允许稍后重试
          this.$message({ message: ret.msg || '在线答辩房间尚未准备完成，请稍后重试', type: 'warning' });
        }
      });
    },
    getEnterWindow(item) { //进入时间窗：开始时间-提前进入分钟数 至 结束时间+允许延时分钟数
      const start = this.parseTime(item.groupStartTime);
      const end = this.parseTime(item.groupEndTime);
      if (start === '-' || end === '-') {
        return '-';
      }
      const enterStart = new Date(start.getTime() - (Number(item.preEnterMinutes) || 0) * 60000);
      const enterEnd = new Date(end.getTime() + (Number(item.endDelayMinutes) || 0) * 60000);
      return this.formatTime(enterStart) + ' 至 ' + this.formatTime(enterEnd);
    },
    parseTime(str) { //解析 yyyy-MM-dd HH:mm:ss
      if (this.$isEmpty(str)) {
        return '-';
      }
      const date = new Date(String(str).replace(/-/g, '/'));
      return isNaN(date.getTime()) ? '-' : date;
    },
    formatTime(date) { //格式化时间为 yyyy-MM-dd HH:mm:ss
      const pad = (n) => (n < 10 ? '0' + n : '' + n);
      return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()) +
        ' ' + pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds());
    },
    formatSize(size) { //字节转可读大小
      if (this.$isEmpty(size) || isNaN(Number(size))) {
        return '-';
      }
      const kb = Number(size) / 1024;
      if (kb < 1024) {
        return kb.toFixed(1) + 'KB';
      }
      return (kb / 1024).toFixed(1) + 'MB';
    },
    downloadAttachment(attachment) {
        this.$downLoadFile(attachment.attachmentUrl, attachment.attachmentName || '在线答辩附件');
    }
  },
};
</script>

<style lang="less">
@import '../../styles/base.less';
.el-onlineDefense {
  .defense-card {
    border: 1px solid rgb(230, 230, 231);
    padding: 20px;
    margin-bottom: 15px;
    border-radius: 10px;
    box-shadow: 1px 2px 4px rgb(230, 230, 231);
    .card-head {
      margin-bottom: 10px;
      .card-title {
        font-size: 16px;
        font-weight: bold;
        margin-right: 10px;
      }
    }
    .card-desc {
      color: #8c939d;
      margin-bottom: 10px;
      font-size: 14px;
    }
    .card-info {
      font-size: 14px;
      color: #606266;
      p {
        margin: 5px 0;
        .info-label {
          color: #909399;
        }
      }
    }
    .card-btns {
      margin-top: 15px;
    }
  }
  .material-box {
    margin-top: 20px;
    .material-head {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      overflow: hidden;
      .material-title {
        font-size: 16px;
        font-weight: bold;
        float: left;
        line-height: 32px;
      }
      .el-upload {
        float: right;
      }
    }
    .material-tip {
      font-size: 12px;
      color: #909399;
      margin-bottom: 10px;
    }
  }
  .material-format-tip {
    line-height: 20px;
    white-space: normal;
  }
  .danger-btn {
    color: #f56c6c;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/onlineDefense/OnlineDefense.vue